import React from 'react'
// components
import { ReduxInput } from 'components/FormElements'
// utils
import { required } from 'utils/validators'

interface Props {
  field: string
}

const MakePrivate: React.FC<Props> = ({ field }) => {
  return <ReduxInput validate={required} label='Success Text' name={`${field}.successText`} />
}

export default MakePrivate
